import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-mail",
  templateUrl: "./mail.component.html",
  styleUrls: ["./mail.component.scss"],
})
export class MailComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
